<template>
  <div class="layout">
    <Layout>
      <AdminHeader />
      <Layout>
        <Sider hide-trigger :style="{background: '#fff'}">
          <AdminLeftMenu />
          <div class="slider-sep"></div>
        </Sider>
        <Layout class="admin-right-wrap">
          <AdminContentBread />
          <!--页面内容主体开始-->
          <Content class="admin-wrap">
            <Alert type="warning">
              为了保证页面美观，请您按照提示尺寸上传图片。
              <template slot="desc">
                <div class="upload-notice-txt" v-html="GLOBAL_API.uploadPictureNitice[formValidate.block]"></div>
              </template>
            </Alert>
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
              <FormItem label="链接标题" prop="title">
                <Input v-model="formValidate.title" placeholder="请输入链接标题"></Input>
              </FormItem>
              <FormItem label="链接地址" prop="link">
                <Input v-model="formValidate.link" placeholder="请输入链接地址"></Input>
              </FormItem>
              <FormItem label="页面位置" prop="block">
                <RadioGroup v-model="formValidate.block">
                  <Radio :label="1">首页Banner</Radio>
                  <Radio :label="2">协会新闻</Radio>
                  <Radio :label="3">视频报道</Radio>
                  <Radio :label="4">多彩人生</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem label="图片" prop="picture">
                <img v-if="coverPic!=''&&formValidate.block==1" :src="coverPic" class="upload-banner" >
                <img v-else-if="coverPic!=''&&formValidate.block==2" :src="coverPic" class="upload-news" >
                <img v-else-if="coverPic!=''&&formValidate.block==3" :src="coverPic" class="upload-videos" >
                <img v-else-if="coverPic!=''&&formValidate.block==4" :src="coverPic" class="upload-colors" >
                <Upload
                 :action="GLOBAL_API.apiUrl + '/uploads/picture-for-news'"
                 :headers='{"Authorization": "Bearer " + token}'
                 :on-success="uploaded"
                >
                  <Button icon="ios-cloud-upload-outline">上传图片</Button>
                </Upload>
              </FormItem>
              <FormItem>
                <Button type="primary" @click="handleSubmit('formValidate')">保存</Button>
              </FormItem>
            </Form>
          </Content>
          <!--页面内容主体结束-->
        </Layout>
      </Layout>
    </Layout>
  </div>
</template>
<script>
import axios from "axios"
import AdminLeftMenu from '@/components/AdminLeftMenu.vue'
import AdminContentBread from '@/components/AdminContentBread.vue'
import AdminHeader from '@/components/AdminHeader.vue'
export default {
  components: {
    AdminLeftMenu,
    AdminContentBread,
    AdminHeader
  },

  data() {
    return {
      token: '',
      coverPic: '',
      formValidate: {
        title: '',
        link: '',
        block: '',
        picture:'',
      },
      ruleValidate: {
        title: [
          { required: true, message: '请您输入链接标题', trigger: 'blur' }
        ],
        link: [
          { required: true, message: '请您输入链接URL', trigger: 'blur' }
        ],
        block: [
          { type: 'number', required: true, message: '请您选择所在页面位置', trigger: 'change' }
        ],
        picture: [
          { required: true, message: '请您上传图片', trigger: 'blur' }
        ]
      }
    }
  },

  //页面加载完成
  mounted: function() {
    //初始化用户信息
    this.initAuthData()
  },

  //自定义页面方法
  methods: {
    //初始化页面基础信息
    initAuthData() {
      let admin = JSON.parse(localStorage.getItem("adminInfo"));
      if(admin!=null) {
        this.token = admin.token
      }
    },

    //文件上传成功
    uploaded (response) {
      let code = parseInt(response.uploaded)
      if(!isNaN(code) && code==1) {
        this.formValidate.picture = response.url
        this.coverPic =  response.url
      }
    },

    //表单提交
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          let vm = this
          //vm.formValidate.columnName = 
          axios.post(
            vm.GLOBAL_API.apiUrl + "/manage/blocks/save-for-index-sliders",
            vm.formValidate,
            {
              headers: {
                'content-type': 'application/json',
                "Authorization": "Bearer " + vm.token
              }
            }
          ).then(function(res) {
            let error = res.data.code
            if(!isNaN(error) && error==0) {
              vm.$Message.success({
                content: res.data.message,
                duration: 1,
                closable: true,
                onClose:function() {
                  window.location.reload()
                }
              });
            }
          }).catch(function(error) {
            console.log(error)
          });
        } else {
          this.$Message.error('请您完善表单数据');
        }
      })
    },

  }
}
</script>